/* eslint-disable max-lines-per-function */
import { ButtonClickedEvent, LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { Analytics } from './analytics.constants';
export const usePrivacyAndSecurityAnalytics = () => {
  const fireEvent = useAnalyticsEvents();
  const fireExpandCollapseAllSectionsEvent = isExpanded => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: isExpanded ? Analytics.subjectId.expandAllSectionsClicked : Analytics.subjectId.collapseAllSectionsClicked
    });
  };
  const fireReadMoreLessEvent = isExpanded => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: isExpanded ? Analytics.subjectId.readMoreClicked : Analytics.subjectId.readLessClicked
    });
  };
  const fireExpandSectionEvent = linkText => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: Analytics.subjectId.expandSectionClicked,
      attributes: {
        linkText
      }
    });
  };
  const fireFeedbackCollectorEvent = isYes => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: isYes ? Analytics.subjectId.feedbackCollectorYesClicked : Analytics.subjectId.feedbackCollectorNoClicked
    });
  };
  const fireFeedbackCollectorSubmitEvent = feedbackType => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: Analytics.subjectId.feedbackCollectorSubmitClicked,
      attributes: {
        feedbackType
      }
    });
  };
  const fireFeedbackCollectorPopupCloseEvent = () => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: Analytics.subjectId.feedbackCollectorPopupClosed
    });
  };
  const fireContactThePartnerEvent = () => {
    fireEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: Analytics.subjectId.contactThePartnerClicked
    });
  };
  const fireViewDetailsEvent = linkText => {
    fireEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: Analytics.subjectId.viewDetailsClicked,
      attributes: {
        linkText
      }
    });
  };
  const fireQuestionnaireUiLinkEvent = linkText => {
    fireEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: Analytics.subjectId.questionnaireUiLinkClicked,
      attributes: {
        linkText
      }
    });
  };
  const fireQuestionnaireUiEmailEvent = () => {
    fireEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: Analytics.subjectId.questionnaireUiEmailClicked
    });
  };
  const fireTrustProgramsLinkEvent = linkText => {
    fireEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: Analytics.subjectId.aboutProgramClicked,
      attributes: {
        linkText
      }
    });
  };
  return {
    fireExpandCollapseAllSectionsEvent,
    fireReadMoreLessEvent,
    fireExpandSectionEvent,
    fireFeedbackCollectorEvent,
    fireFeedbackCollectorSubmitEvent,
    fireFeedbackCollectorPopupCloseEvent,
    fireContactThePartnerEvent,
    fireViewDetailsEvent,
    fireQuestionnaireUiLinkEvent,
    fireQuestionnaireUiEmailEvent,
    fireTrustProgramsLinkEvent
  };
};